import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { Schedule } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesScheduleRoutes } from './routes';
import { QuotesScheduleTransport } from './types';

export class QuotesScheduleRestful extends RestfulClient implements QuotesScheduleTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.scheduleUrl, session, { 'x-device-key': true }, proxyClientOptions(undefined, 'apikey'));
  }

  getSchedule = async (): SafePromise<Schedule> => {
    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesScheduleRoutes.schedule);
    const url = this.URL(path, this.withUpstreamCredentials({}, { apikey: env.scheduleKey }));
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
